import React from 'react';
import SwiperCore, { Swiper as SwiperClass, Mousewheel } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/react';
// import Swiper styles
import 'swiper/swiper-bundle.min.css';

SwiperCore.use([Mousewheel]);

interface Props {
  className?: string;
  initialSlide?: number;
  onSwiper?: (swiper: SwiperClass) => void;
  children: JSX.Element[];
}

class SwiperCarousel extends React.Component<Props> {
  render(): JSX.Element {
    const { children, initialSlide } = this.props;
    return (
      <Swiper
        spaceBetween={ 24 }
        slidesPerView="auto"
        mousewheel
        onSwiper={ this.props.onSwiper ? this.props.onSwiper.bind(this) : () => null }
        initialSlide={ initialSlide ? initialSlide : 0 }
      >
        { children.map((c, i) => <SwiperSlide key={ `slide-${i}` }>{ c }</SwiperSlide>) }
      </Swiper>
    );
  }
}

export default SwiperCarousel;